<template>
	<v-container id="alerts" class="py-0">
        <v-card :href="$store.state.client_vars.alerts.alertLink" color="#ff6d00">
            <v-container class="px-0 py-0">
                <h2 class="d-flex flex-column flex-sm-row">
                    <div class="alert__level">
                        <span>
                            {{ $store.state.client_vars.alerts.alertLevel }}
                        </span>
                    </div>
                    <span class="alert__text d-flex">
                        <span>
                            {{ $store.state.client_vars.alerts.alertText }}
                        </span>
                        <v-btn icon class="alert__icon--arrow ml-auto align-self-center" title="Go to the linked website for more information on this alert">
                            <!-- <v-icon :color="alertLevel === 'high' ? 'error' : 'secondary'">mdi-chevron-right</v-icon> -->
                            <img src="@/assets/icons/arrow-black.svg" alt="">
                        </v-btn>
                    </span>
                </h2>
            </v-container>
        </v-card>
	</v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ]
    }
</script>

<style scoped lang="scss">
    #alerts {
        position: relative;
        // bottom: -30px;
        left: 0;
        right: 0;

        .alert__level {
            color: white;
            background-color: #121212;
            padding: 23px 60px;
            text-align: center;
            align-items: center;
            display: flex;
            text-transform: uppercase;
            font-weight: 600;
        }

        .alert__text {
            padding: 23px 43px;
            flex: 1 1 auto;
            align-items: center;
            font-weight: 500;

            img {
                margin-top: 4px;
            }
        }

        h2 {
            padding: 0;
            font-size: 21px;
        }

        .error-text {
            color: var(--v-error-base);
        }

        .secondary-text {
            color: var(--v-secondary-base);
        }

        .v-card {
            width: 100%;
            
            &::after {
                clear: both;
            }
        }
    }
</style>